import React from 'react'
import './index.css'
import FlexColumn from 'components/FlexColumn'
import logUtil from 'utils/log'
import H3 from 'components/H3'
import P from 'components/P'
import useSelector from 'hooks/use-selector'
import getCurrentMemberFirstName from 'modules/squad/redux/selectors/get-current-member-first-name'
import View from 'components/View'
import Image from 'components/Image'
import hasSuperLikedProductsByMemberIdSquadSelector from 'modules/squad/redux/selectors/has-super-liked-products-by-member-id'
import ButtonLink from 'components/ButtonLink'
import {
  SQUAD_LIKED_PRODUCTS_ID,
  SQUAD_MEMBER_SUPER_LIKED_PRODUCTS_ID
} from 'modules/squad/constants'
import logEventAnalyticsUtil from 'utils/analytics/log-event'

const TITLE_SQUAD_MATCHES = 'Squad matches:'
const TITLE_ITEMS_YOU_BOTH_LOVED = 'items you both loved'
const DESCRIPTION = 'You currently don’t have any matches.'
const TRY_YOUR_FRIENDS_SAMPLE_1 = 'Try your friend’s samples to uncover shared interests'
const TRY_YOUR_FRIENDS_SAMPLE_2 = 'and discover new products you both appreciate'

const ANALYTICS_EVENT = {
  SHOW_SQUAD_ITEMS_YOU_BOTH_LOVED_EMPTY: 'SHOW_SQUAD_ITEMS_YOU_BOTH_LOVED_EMPTY',
  SQUAD_ITEMS_YOU_BOTH_LOVED_EMPTY_VIEW_FRIEND_SAMPLES: 'SQUAD_ITEMS_YOU_BOTH_LOVED_EMPTY_VIEW_FRIEND_SAMPLES'
}
export default function ItemsYouBothLovedEmpty () {
  const currentMemberFirstName = useSelector(getCurrentMemberFirstName)
  const hasSuperLikedProducts = useSelector(hasSuperLikedProductsByMemberIdSquadSelector)
  const debugProps = {
    currentMemberFirstName,
    hasSuperLikedProducts
  }

  const handleClickViewSamples = () => {
    logUtil('ItemsYouBothLovedEmpty#handleClickViewSamples').debug('[start]')
    logEventAnalyticsUtil(ANALYTICS_EVENT.SQUAD_ITEMS_YOU_BOTH_LOVED_EMPTY_VIEW_FRIEND_SAMPLES)
  }

  React.useEffect(() => {
    logEventAnalyticsUtil(ANALYTICS_EVENT.SHOW_SQUAD_ITEMS_YOU_BOTH_LOVED_EMPTY)
  }, [])

  logUtil('ItemsYouBothLovedEmpty').debug('debugProps=', debugProps)
  return (
    <FlexColumn
      className='squad-items-you-both-loved-content squad-items-you-both-loved-content_empty'
    >
      <H3>{TITLE_SQUAD_MATCHES}</H3>
      <H3>{TITLE_ITEMS_YOU_BOTH_LOVED}</H3>
      <P className='squad-items-you-both-loved-empty-description'>{DESCRIPTION}</P>
      <P className='squad-items-you-both-loved-empty-try'>
        {TRY_YOUR_FRIENDS_SAMPLE_1}
        <br />
        {TRY_YOUR_FRIENDS_SAMPLE_2}
      </P>
      <View className='squad-items-you-both-loved-empty-image'>
        <Image
          src='https://cdn.shopify.com/s/files/1/0569/9957/5718/files/Rating_cardx_9de489d7-e65b-4d04-8f91-17cceabdb492.png?v=1695933106'
          alt='rating card'
        />
      </View>
      {!!hasSuperLikedProducts && (
        <ButtonLink href={`#${hasSuperLikedProducts ? SQUAD_MEMBER_SUPER_LIKED_PRODUCTS_ID : SQUAD_LIKED_PRODUCTS_ID}`} onClick={handleClickViewSamples}>
          View {currentMemberFirstName}’s {hasSuperLikedProducts ? 'superliked' : 'liked'} samples
        </ButtonLink>
      )}
    </FlexColumn>
  )
}
